import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import KeyboardBackspaceOutlinedIcon from '@mui/icons-material/KeyboardBackspaceOutlined';
import { useOnboardingState } from '../../hooks/useOnboardingState.jsx';
import { onboardingV2Api } from '@/data/api/onboardingV2';
import Logo from '@/Asset/images/logo-blaxk.webp';
import VisualImage from '@/Asset/images/step-3.png';
import Toast from '@/utils/toastManager';
import EastIcon from '@mui/icons-material/East';
import StepIndicator from '../StepIndicator/StepIndicator';
import './Step6.css';

const Step6 = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const { state, updateState } = useOnboardingState();
	const stepItems = [1, 2, 3, 4, 5, 6];
	const totalSteps = 6;
	const [challengeInput, setChallengeInput] = useState('');

	// Validation function for StepIndicator - checks if current step is valid
	// Step 6 doesn't have required validation (input is optional), so it always returns true
	const validateStep = () => {
		// Step 6 is optional for challenge input, so we always allow navigation
		return true;
	};

	// Handle validation failure for StepIndicator
	const handleValidationFail = () => {
		// Toast is already shown in validateStep
	};

	const handleSeeResults = async () => {
		const onboardingPreferences = {
			...(state.onboardingPreferences || {}),
			studioBiggestChallenge: challengeInput
		};

		try {
			await onboardingV2Api.updateOnboardingData({
				onboardingStep: 10,
				onboardingPreferences
			});
		} catch (error) {
			Toast.error('Failed to save this step. Please try again.');
			return;
		}

		updateState({
			currentStep: 10,
			studioBiggestChallenge: challengeInput,
			onboardingPreferences
		});
		navigate(`/onboarding/recommended-videos?${new URLSearchParams(location.search).toString()}`);
	};

	const handleSkip = async () => {
		try {
			await onboardingV2Api.updateOnboardingData({
				onboardingStep: 10
			});
		} catch (error) {
			Toast.error('Failed to save this step. Please try again.');
			return;
		}

		updateState({ currentStep: 10 });
		navigate('/');
	};

	return (
		<div className="onboarding-step-six">
			<div className="onboarding-step-six__grid-overlay" />
			<div className="onboarding-step-six__content">
				<header className="onboarding-step-six__header">
					<div className="onboarding-step-six__brand-row">
						<button
							type="button"
							className="onboarding-step-six__back-btn"
							onClick={() => navigate(`/onboarding/step-5?${new URLSearchParams(location.search).toString()}`)}
						>
							<KeyboardBackspaceOutlinedIcon />
						</button>
						<img src={Logo} alt="The Godfrey Method On Demand" className="onboarding-step-six__logo" />
					</div>

					<StepIndicator 
						totalSteps={totalSteps} 
						currentStep={6}
						validateStep={validateStep}
						onValidationFail={handleValidationFail}
						basePath="/onboarding"
					/>
				</header>

				<main className="onboarding-step-six__main">
					<section className="onboarding-step-six__layout">
						<div className="onboarding-step-six__main-panel">
							<h1 className="onboarding-step-six__title">What Is Your Biggest Challenge As A Studio / Team Right Now?</h1>
							<div className="onboarding-step-six__input-wrap">
								<textarea
									className="onboarding-step-six__input"
									placeholder="Optional"
									value={challengeInput}
									onChange={event => setChallengeInput(event.target.value)}
								/>
							</div>
							<button type="button" onClick={handleSeeResults} className="onboarding-step-six__cta-btn">
								See My Results <EastIcon/>
							</button>
						</div>
					</section>
				</main>

				<footer className="onboarding-step-six__footer">
					<button type="button" onClick={handleSkip} className="onboarding-step-six__skip-btn">
						Skip
					</button>
				</footer>
			</div>
		</div>
	);
};

export default Step6;
